export const BackendUrls = {
  DEV_API_URL: "https://dev.api.elsa.la/",
  // DEV_API_URL: "http://localhost:8000/",
  PROD_API_URL: "https://api.elsa.la/",
  // DEV_API_URL: "https://api.elsa.la/",
};
